export enum RippleSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extra-large',
}

export interface RippleArgs {
  isFullPage: boolean;
  flexCenter: boolean;
  positionRelative: boolean;
  size: RippleSizes;
}
